import { MsgExecuteContract } from "@goblinhunt/cosmes/client"
import { UnstakeInfo } from "models/staking/UnstakeResponse"
import { TokenInfoResponse } from "models/token/TokenInfoResponse"
import { useWallet } from "provider/WalletProvider"
import { useEffect, useState } from "react"
import { fromDenom, numberPendek } from "utils/Helpers"
import { showLoadingToast, showTxToast } from "utils/Toasts"

type Prop = {
    unstakeInfo: UnstakeInfo,
    tokenInfo: TokenInfoResponse,
    contractAddress: string
}

export function UnstakeLiquidityListItem({ unstakeInfo, tokenInfo, contractAddress }: Prop) {
    const { address: sender, post } = useWallet()

    const getDate = () => {
        const milliseconds = Number(unstakeInfo.released_at) / 1_000_000
        return new Date(milliseconds)
    }

    const getFormattedDate = () => {
        return getDate().toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        });
    }


    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        const calculateTimeLeft = () => {
            const diffMilliseconds = Number(unstakeInfo.released_at) / 1_000_000 - Date.now();

            if (diffMilliseconds < 1) {
                setTimeLeft("00:00:00")
                return
            }

            // Convert the difference to hours, minutes, and seconds
            const diffInSeconds = Math.floor(diffMilliseconds / 1000);
            const hours = Math.floor(diffInSeconds / 3600);
            const minutes = Math.floor((diffInSeconds % 3600) / 60);
            const seconds = diffInSeconds % 60;

            // Format the timer
            const formattedTimer = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            setTimeLeft(formattedTimer)
        };

        const timerInterval = setInterval(calculateTimeLeft, 1000);
        calculateTimeLeft(); // Initial call to set the initial value

        return () => clearInterval(timerInterval);
    }, []);

    const onRedeem = async () => {
        const redeemMsg = {
            redeem: {
                id: unstakeInfo.id
            }
        }

        const executeMsg = new MsgExecuteContract({
            sender: sender!,
            contract: contractAddress!,
            msg: redeemMsg,
            funds: []
        })
        const msgs = [executeMsg]

        const result = await showLoadingToast("Signing transaction", () => post({
            msgs,
        }))

        await showTxToast(result)
    }

    return <li className="d-flex mb-4 pb-1">
        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
            <div className="me-2">
                <h6 className="mb-0">{timeLeft}</h6>
                <small className="text-muted">{getFormattedDate()}</small>
            </div>
            <div className="user-progress d-flex align-items-center gap-1">
                <h6 className="mb-0">
                    {numberPendek(fromDenom(Number(unstakeInfo.amount), tokenInfo?.decimals ?? 6 ?? 6))}
                </h6>
                <span className="text-muted">{tokenInfo?.symbol}</span>
            </div>
        </div>
        <button onClick={onRedeem} disabled={timeLeft != "00:00:00"} className="btn btn-primary ms-4">Claim</button>
    </li>
}